import * as React from 'react'
import * as css from './DotLeaderList.module.css'

const DotLeaderList = ({ items }) => (
  <ul className="!p-0">
    {items?.map(({ left, right }, key) => (
      <li className={css.item} key={key}>
        <span>{left}</span>
        <span className={css.dots}> ... </span>
        <span className="text-right">{right}</span>
      </li>
    ))}
  </ul>
)

export default DotLeaderList
